const steps = [
  { title: "Prepare", summary: "Prepare your final file and metadata.", detail: "Choose your original file, add a title and optional JSON metadata. Check every detail: an inscription cannot be edited after it is published. Only publish work you have the rights to use." },
  { title: "Inscribe", summary: "Review the cost and destination before signing.", detail: "Use Artefact’s native inscription tool for one work or a batch. Your wallet signs only after you review the files, metadata, destination and total cost. Nothing is sent just by opening the tool. Confirmation time depends on Bitcoin." },
  { title: "Exhibit", summary: "Exhibit your confirmed inscription or offer it at auction.", detail: "Once confirmed and indexed, add the work to your artist archive, curate an exhibition, or create an English or Dutch auction. Website presentation stays editable; your original inscription stays on Bitcoin." },
];

export function ArchiveSteps() {
  return <section className="ar-archive-steps" aria-label="From file to inscription">
    <ol>{steps.map((step, index) => <li key={step.title}>
      <details>
        <summary><span className="ar-step-number" aria-hidden="true">0{index + 1}</span>
          <span><span className="ar-step-title">{step.title}</span><span className="ar-step-summary">{step.summary}</span></span>
          <span className="ar-step-toggle" aria-hidden="true" />
        </summary>
        <p>{step.detail}</p>
      </details>
    </li>)}</ol>
  </section>;
}
